module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/spinner-40441185cd6e517e7779558cdbd91dc4.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/spinner.svg
// module id = d45b
// module chunks = 24